import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { Collection } from './components/Collection';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Library } from './components/Library';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Author } from './components/Author';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink antialiased" data-id="element-0" data-mp="23vuokdaowwv5">
      <MetaPixel data-id="element-1" data-mp="3ikh829m9asyz" />
      <Hero data-id="element-2" data-mp="3iiweonbohg2p" />
      <main data-id="element-3" data-mp="3ij61y35c994p">
        <Collection data-id="element-4" data-mp="3ijpc2xoqyt86" />
        <BeforeAfter data-id="element-5" data-mp="3ii4qvyobommz" />
        <PainPoints data-id="element-6" data-mp="3ml14tc2x3ukl" />
        <Volumes data-id="element-7" data-mp="3mkhm3t5g125i" />
        <Library data-id="element-8" data-mp="3mjzrt22ccy08" />
        <Bonuses data-id="element-9" data-mp="3mjga9mglsbmq" />
        <Offer data-id="element-10" data-mp="3rc9e8848zfxr" />
        <Guarantee data-id="element-11" data-mp="3rbr9so7flver" />
        <Testimonials data-id="element-12" data-mp="3rdaq2et386gj" />
        <Author data-id="element-13" data-mp="3rcsulke91w9o" />
        <FAQ data-id="element-14" data-mp="3recctgjguhe3" />
        <FinalCTA data-id="element-15" data-mp="5yj0slx59ec" />
      </main>
      <Footer data-id="element-16" data-mp="6801qozk67w" />
      <FloatingCTA data-id="element-17" data-mp="4n5i12o8na1" />
      <PurchasePopup data-id="element-18" data-mp="56m9egl55mh" />
    </div>;
}